// src/components/TimeworksPresskit.tsx
import PresskitTemplate from "./PresskitTemplate";
import logo1 from "../assets/presskit/BONEDLogo1.png";
import logo2 from "../assets/presskit/BONEDLogo2.png";
import mascot1 from "../assets/presskit/BONEDMascot1.png";
import mascot2 from "../assets/presskit/BONEDMascot2.png";
import mascot3 from "../assets/presskit/BONEDMascot3.png";
import mascot4 from "../assets/presskit/BONEDMascot4.png";
import mascot5 from "../assets/presskit/BONEDMascot5.png";
import mascot6 from "../assets/presskit/BONEDMascot6.png";
import mascot7 from "../assets/presskit/BONEDMascot7.png";
import banner1 from "../assets/presskit/BONEDBanner1.png";
import screenshot1 from "../assets/presskit/BONEDScreenshot1.jpg";
import screenshot2 from "../assets/presskit/BONEDScreenshot2.jpg";
import screenshot3 from "../assets/presskit/BONEDScreenshot3.jpg";

const BONEDPresskit = () => {
  return (
    <PresskitTemplate
      title="BONED"
      developer="Guild Cheese"
      publisher="Starworks Studios"
      platform="PC (Steam)"
      socialMedia="https://linktr.ee/starworksstudios"
      website="https://www.starworks-studios.com/games/BONED"
      description="Boned is a silly, fast-paced multiplayer party game, inspired by arcade beloved Killer Queen and other multi-player frenzies. Take the role of a canine cadet and get into space-- collect toys, eliminate opponents, and get that bone!"
      history={'Boned is a silly, fast-paced multiplayer party game, inspired by arcade beloved Killer Queen and other multi-player frenzies! During our time at MAGFest in 2024 we were exposed to the cabinet game, Killer Queen. We found ourselves hooked, and we were inspired by the game\'s mechanics. Taking inspiration from Killer Queen, we began to ideate on BONED.'}
      features={[
        "Play BONED in a 1v1 or 2v2 setting, take the role of a canine astronaut and launch into space. ",
        "Drill through planets, slingshot around gravitational fields, and bring your team to victory. ",
        "Collect toys by drilling into the planet cores, then fire it off to eliminate enemies, or take it back to home base to score for your team.",
        "Make sure to keep an eye out for “The Bone”, too!",
      ]}
      steamLink="https://store.steampowered.com/widget/3127600/"
      trailerUrls={["https://www.youtube.com/embed/JwLy8d7DHLA"]}
      screenshotUrls={[screenshot1, screenshot2, screenshot3]}
      logos={[logo1, logo2]}
      banners={[banner1]}
      mascots={[mascot1, mascot2, mascot3, mascot4, mascot5, mascot6, mascot7]}
      aboutDeveloper={"Guild Cheese is a vibrant game studio born from the creative minds of Drexel University students! We are a team of aspiring game developers dedicated to bringing cool experiences to players everywhere. As participants in Drexel's Junior Workshop, we've embarked on an exciting journey to develop our own mock studio!"}
      aboutPublisher={'🌟 Starworks Studios is a scrappy team of Drexel game developers working on games in Philadelphia starting in 2021.\n💫 Our core mission is to bring the easy and affordable fun of indie games to a wider market with high communication and fast turnaround to fans.'}
      credits={`Colin Page - Programmer
Ethan Whiting - Producer
Thomas Ludin - Marketing Lead
Miguel Geniza - Audio
Owen Mearns - 3D Modeling
Brigitte Lubker - UI Artist
Rui Huang - Programmer
Quinn Alpern - Production
Jordyn Morris - 2D Artist
Nick Hom - Programmer
Quinn Williams - Animation
Carolina Escobar - 2D Artist
Adrian Bernales - 2D Artist
Braden Kovalovich - Programmer
Camryn Schroder - 2D/3D Artist
Luca Ruggeri - Programmer
Quy Van - Programmer
Leah Jorge - Programmer
`}
    />
  );
};

export default BONEDPresskit;
